import takeRequest from '~/store/takeRequest';

import {
  fetchAddressFromZipCode,
  fetchAgreements,
  fetchFinancialInstitutions,
  fetchFinancialInstitutionsForDeposit,
  fetchTicketBanks,
  fetchTicketFinancialInstitutions,
  getUserNotifications,
  markNotificationsAsRead,
  getParameter,
  sendEvent,
} from '~/store/utilities/actions';

export function* utilitiesSaga() {
  yield takeRequest(fetchAgreements);
  yield takeRequest(fetchFinancialInstitutions);
  yield takeRequest(fetchAddressFromZipCode);
  yield takeRequest(fetchFinancialInstitutionsForDeposit);
  yield takeRequest(fetchTicketBanks);
  yield takeRequest(fetchTicketFinancialInstitutions);
  yield takeRequest(getUserNotifications);
  yield takeRequest(markNotificationsAsRead);
  yield takeRequest(getParameter);
  yield takeRequest(sendEvent);
}
